import { Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import KeyHighlightItem from 'components/Pages/ArticleParts/KeyHighlightItem';

const KeyHighlights = ({ fields, rendering, className }: ComponentProps): JSX.Element => {
  const { anchorId, backgroundClass } = useHelpers(rendering);

  return (
    <div className={className}>
      <div
        id={anchorId}
        className={`key-highlights p-4 ${backgroundClass}`}
        data-e2e-component-uid={rendering.uid}
      >
        <Text field={fields.title} className="h2 background-to-change pb-2" tag="h2" />
        {fields.items.map((item, idx) => (
          <KeyHighlightItem
            key={item.id}
            fields={item.fields}
            rendering={rendering}
            idx={idx}
            className="mt-3"
          />
        ))}
      </div>
    </div>
  );
};

export default withDatasourceCheck()(KeyHighlights);
